import * as actionTypes from "../actionTypes";
import {updateObject} from "../../shared/utils/updateObject";
import * as storageConstants from "../../shared/utils/constants/storage";
import {EXPAND_MOBILE_MENU, FRONTEND_CONFIGURATION} from "../../shared/utils/constants/storage";
import {getCompanyNameFromToken, getDefaultOrSessionCompany} from "../../shared/utils/storageUtils";
import {initialCompaniesState, initialUserClaimsState} from "./helper";
import jwt_decode from "jwt-decode";

const initialState = {
    token: "",
    frontendConfiguration: JSON.parse(sessionStorage.getItem(FRONTEND_CONFIGURATION)),
    isRedirecting: true,
    expandMobileMenu: sessionStorage.getItem(EXPAND_MOBILE_MENU) === "true" ?? false,
    userClaims: initialUserClaimsState,
    companies: initialCompaniesState,
    selectedCompany: getDefaultOrSessionCompany(),
    contactNumbers: {},
    cacheSimsLoading: false,
    cacheDigitalContractLoading: false
};

const setLoginParams = (state, action) => {
    const tmpSelected = {
        ...state.selectedCompany,
        integrationId: action.integrationId,
        changeInSelf: action.claims.changeInSelf,
        livelloDiAssistenza: action.claims.livelloDiAssistenza,
        livelloDiAssistenzaId: action.claims.livelloDiAssistenzaId,
        name: getCompanyNameFromToken(action.token)
    }
    return updateObject(state, {
        token: action.token,
        userClaims: action.claims,
        selectedCompany: tmpSelected,
        frontendConfiguration: action.frontendConfiguration,
    })
}

const setSelectedCompany = (state, action) => {
    sessionStorage.setItem(storageConstants.COMPANY, JSON.stringify(action.selectedCompany));
    sessionStorage.setItem(storageConstants.TOKEN_NAME, action.token);
    sessionStorage.setItem(storageConstants.FRONTEND_CONFIGURATION, JSON.stringify(action.frontendConfiguration));
    const decodedJwt = jwt_decode(action.token);

    return updateObject(state, {
        selectedCompany: action.selectedCompany,
        userClaims: decodedJwt,
        token: action.token,
        frontendConfiguration: action.frontendConfiguration
    })
}

const fetchCompaniesDataSuccess = (state, action) => {
    const tmpObject = {
        ...state.companies,
        data: action.data,
        count: action.count,
        rowsPerPage: action.rowsPerPage,
        page: action.page

    }
    return updateObject(state, {companies: tmpObject})
}

const setLoading = (state, action) => {
    let tmpObj = {...state.companies, [`${action.name}`]: action.value};
    if (action.value && action.name === "loading") {
        tmpObj = {...tmpObj, count: 0};
    }
    return updateObject(state, {companies: tmpObj});
}

function setFilterCompanies(state, action) {
    const tmpObject = {
        ...state.companies,
        searchText: action.value
    }
    return updateObject(state, {companies: tmpObject});
}

function setContactNumbersForCustomer(state, action) {
    return updateObject(state, {contactNumbers: action.data})
}

const setLoadingContactNumbers = (state, action) => {
    return updateObject(state, {loadingContactNumbers: action.loading})
}

const clearNumbers = (state) => {
    return updateObject(state, {contactNumbers: {}})
}

const logoutUser = (state) => {
    return updateObject(state, initialState);
}

const setExpandMobileMenu = (state, action) => {
    return updateObject(state, {expandMobileMenu: action.payload});
}

const setCacheSimsLoading = (state, action) => {
    return updateObject(state, {cacheSimsLoading: action.payload});
}

const setCacheDigitalContractLoading = (state, action) => {
    return updateObject(state, {cacheDigitalContractLoading: action.payload});
}

const authReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SET_LOGIN_PARAMS:
            return setLoginParams(state, action);
        case actionTypes.FETCH_COMPANIES:
            return fetchCompaniesDataSuccess(state, action);
        case actionTypes.SET_SELECTED_COMPANY:
            return setSelectedCompany(state, action);
        case actionTypes.SET_LOADING_AUTH:
            return setLoading(state, action);
        case actionTypes.SET_FILTER_COMPANIES:
            return setFilterCompanies(state, action);
        case actionTypes.CLEAR_CONTACT_NUMBERS:
            return clearNumbers(state, action);
        case actionTypes.SET_LOADING_CONTACT_NUMBERS:
            return setLoadingContactNumbers(state, action);
        case actionTypes.GET_CONTACT_NUMBERS_FOR_CUSTOMER:
            return setContactNumbersForCustomer(state, action);
        case actionTypes.LOGOUT_USER:
            return logoutUser(state, action);
        case actionTypes.EXPAND_MOBILE_MENU:
            return setExpandMobileMenu(state, action);
        case actionTypes.CACHE_SIMS_LOADING:
            return setCacheSimsLoading(state, action)
        case actionTypes.CACHE_DIGITAL_CONTRACT_LOADING:
            return setCacheDigitalContractLoading(state, action)
        default:
            return state;
    }
};

export default authReducer;
